export default () => {
  $(document).ready(function(e) {
    $('img[usemap]').rwdImageMaps();
  });

  $(function() {
    $('.drawer').drawer();
    $('.drawer-nav ul li a').on('click', function() {
      $('.drawer').drawer('close');
    });
  });

  $(function () {

    var windowWidth = $(window).width();
    var windowSm = 667;

    if (windowWidth <= windowSm) { // スマホ時のjQuery

      // サイト内リンクの設定
      $(function () {

        var headerHight = $('').outerHeight();

        $('a[href^="#"]').click(function(){
          var href = $(this).attr('href');
          var target = $(href == '#' || href == '' ? 'html' : href);
          var position = target.offset().top-headerHight;
          $("html, body").animate({scrollTop:position}, 550, 'swing');
          return false;
        });

        $(window).on('load', function() {
          var url = $(location).attr('href');
          if(url.indexOf('#') != -1){
            var anchor = url.split('#');
            var target = $('#' + anchor[anchor.length - 1]);
            if(target.length){
              var pos = Math.floor(target.offset().top) - headerHight;
              $('html, body').animate({scrollTop:pos}, 500);
            }
          }
        });

      });

      // スマホメニューの設定
      $(function(){
        $('.menu-btn').click(function(){
          $('.sp-menu').slideToggle(200);
          $(this).toggleClass('active');
        });
        $('.sp-menu li a').click(function(){
          $('.sp-menu').css({display:'none'});
          $('.menu-btn').toggleClass('active');
        });
      });

      // ページトップボタンの設定
      $(document).ready(function() {

        var pagetop2 = $('.foot-sp-menu-list li.li-pagetop a');

        pagetop2.click(function () {
          $('body, html').animate({ scrollTop: 0 }, 500);
          return false;
        });
      });

      // 固定ヘッダーの設定
      $(window).on('scroll', function () {
        let $header = $('.kotei-head');
        if ($(window).scrollTop() > 48) {
          $header.addClass('fixed');
        } else {
          $header.removeClass('fixed');
        }
      });

      // 固定フッターはページごとに出し分けるため、各ページのjsで個別に設定

    } else { // PC・タブレット時のjQuery

      // サイト内リンクの設定
      $(function () {

        var headerHight = $('').outerHeight();

        $('a[href^="#"]').click(function(){
          var href = $(this).attr('href');
          var target = $(href == '#' || href == '' ? 'html' : href);
          var position = target.offset().top-headerHight;
          $("html, body").animate({scrollTop:position}, 550, 'swing');
          return false;
        });

        $(window).on('load', function() {
          var url = $(location).attr('href');
          if(url.indexOf('#') != -1){
            var anchor = url.split('#');
            var target = $('#' + anchor[anchor.length - 1]);
            if(target.length){
              var pos = Math.floor(target.offset().top) - headerHight;
              $('html, body').animate({scrollTop:pos}, 500);
            }
          }
        });

      });

      // 固定ヘッダーの設定
      $(window).on('scroll', function () {
        let $header = $('.kotei-head');
        if ($(window).scrollTop() > 180) {
          $header.addClass('fixed');
        } else {
          $header.removeClass('fixed');
        }
      });


      // ページトップボタンの設定
      $(document).ready(function() {

        var pagetop = $('.pagetop');

        pagetop.click(function () {
          $('body, html').animate({ scrollTop: 0 }, 500);
          return false;
        });

      });

    }

  });

  $(function() {

    var $elem = $('.js-img');
    var pc = 'images/';
    var sp = 'images-sp/';
    var replaceWidth = 767;

    function imageSwitch() {
      var windowWidth = parseInt(window.innerWidth);

      $elem.each(function() {
        var $this = $(this);
        if(windowWidth >= replaceWidth) {
          $this.attr('src', $this.attr('src').replace(sp, pc));

        } else {
          $this.attr('src', $this.attr('src').replace(pc, sp));
        }
      });
    }
    imageSwitch();

    var resizeTimer;
    $(window).on('resize', function() {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function() {
        imageSwitch();
      }, 0);
    });

  });

  $(function(){

      var ua = navigator.userAgent;

      if(ua.indexOf('iPhone') > 0 || ua.indexOf('Android') > 0){
          $('.tel-link').each(function(){
              var str = $(this).text();
              $(this).html($('<a>').attr('href', 'tel:' + str.replace(/-/g, '')).append(str + '</a>'));
          });
      }

  });
};
